/* SiliDog quick-shop personalization gate (2026-08-13, v2)
   Horizon's quick-add posts straight to /cart/add with no personalization —
   unfulfillable for a printed tag. This gates the quick-add CLICK (the
   product-form-component handles it internally via fetch; no DOM submit event
   ever fires, so the gate must be capture-phase on click) behind a personalize
   modal, then injects the typed lines into Horizon's OWN form and re-fires the
   native button, so Monster Cart / analytics see a completely normal add.

   v2: the modal renders the product's REAL line set — the quick-add snippet
   stamps data-sdqs-front / data-sdqs-back (CSV of per-line char limits, from
   the same custom.front_line_/back_line_ metafields the PDP uses, 4x20 / 3x20
   default). A bone shows 4 front lines + a collapsed back-of-tag group; a
   design with fewer lines shows fewer.
   Fulfillment contract: properties[lineN] / properties[backlineN] — never rename. */
(function () {
  'use strict';
  var activeForm = null;
  var overlay = null;

  var FRONT_PH = ["e.g. Rex", "Phone number (optional)", "Line 3 (optional)", "Line 4 (optional)"];
  var FRONT_LABEL = ["Pet’s name", "Phone", "Line 3", "Line 4"];

  function limits(csv) {
    if (!csv) return [];
    return csv.split(',').map(function (n) { return parseInt(n, 10) || 20; });
  }

  // backOnly: a design tag (custom.disable_front_customization) whose front is the
  // art, so the back carries the name and back line 1 is the required one.
  function fieldHTML(idx, lim, side, backOnly) {
    var key = side === 'front' ? 'line' + (idx + 1) : 'backline' + (idx + 1);
    var required = idx === 0 && (side === 'front' || backOnly);
    var label = side === 'front'
      ? FRONT_LABEL[idx] + (required ? '' : ' <em>(optional)</em>')
      : 'Back line ' + (idx + 1) + (required ? '' : ' <em>(optional)</em>');
    var ph = side === 'front' || backOnly ? (FRONT_PH[idx] || '') : '';
    return '<label class="sdqs-label" for="sdqs-' + key + '">' + label + '</label>' +
      '<div class="sdqs-field"><input id="sdqs-' + key + '" data-sdqs-key="' + key + '" type="text" maxlength="' + lim + '" placeholder="' + ph + '" autocomplete="off"' + (required ? ' autocapitalize="words"' : '') + '><span class="sdqs-count">0/' + lim + '</span></div>';
  }

  function buildModal() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'sdqs-overlay';
    overlay.setAttribute('hidden', '');
    overlay.innerHTML =
      '<div class="sdqs-modal" role="dialog" aria-modal="true" aria-labelledby="sdqs-title">' +
        '<button type="button" class="sdqs-close" aria-label="Close">' +
          '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>' +
        '</button>' +
        '<h3 class="sdqs-title" id="sdqs-title">Personalize your tag</h3>' +
        '<p class="sdqs-sub">Printed, never engraved. Leave any line blank and it stays off the tag.</p>' +
        '<div class="sdqs-fields"></div>' +
        '<button type="button" class="sdqs-add" aria-disabled="true">Add to cart</button>' +
        '<a class="sdqs-more" href="#">See it live on the tag →</a>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelector('.sdqs-close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) close(); });

    overlay.querySelector('.sdqs-add').addEventListener('click', function () {
      var add = this;
      if (add.getAttribute('aria-disabled') === 'true' || !activeForm) return;
      var form = activeForm;
      // strip any previous run, then inject every non-empty line as a hidden
      // property input on Horizon's own form
      form.querySelectorAll('input[name^="properties["]').forEach(function (n) { n.remove(); });
      overlay.querySelectorAll('[data-sdqs-key]').forEach(function (inp) {
        var val = inp.value.trim();
        if (!val) return;
        var h = document.createElement('input');
        h.type = 'hidden';
        h.name = 'properties[' + inp.getAttribute('data-sdqs-key') + ']';
        h.value = val;
        form.appendChild(h);
      });
      var btn = form.querySelector('.quick-add__button--add') || form.querySelector('[type="submit"]');
      close();
      form.setAttribute('data-sdqs-ok', '1');
      if (btn) btn.click();
      else if (form.requestSubmit) form.requestSubmit();
      setTimeout(function () { form.removeAttribute('data-sdqs-ok'); }, 1500);
    });
    return overlay;
  }

  function open(form) {
    buildModal();
    activeForm = form;
    var d = form.dataset;
    var front = limits(d.sdqsFront);
    var back = limits(d.sdqsBack);
    if (!front.length && !back.length) { front = [20, 20, 20, 20]; back = [20, 20, 20]; }

    overlay.querySelector('.sdqs-title').textContent = d.sdqsTitle ? 'Personalize your ' + d.sdqsTitle : 'Personalize your tag';
    var more = overlay.querySelector('.sdqs-more');
    if (d.sdqsUrl) { more.href = d.sdqsUrl; more.style.display = ''; } else { more.style.display = 'none'; }

    var html = '';
    front.forEach(function (lim, i) { html += fieldHTML(i, lim, 'front'); });
    if (back.length && !front.length) {
      // Design tags (Halloween, holidays) have no front lines. Their back lines used to
      // sit in the collapsed "(optional)" group below, which hid the one required
      // field and left Add to cart greyed out with nothing visible to type in
      // (2026-10-06). Show them open, line 1 required, as the PDP does.
      html += '<p class="sdqs-backhead">Back of tag</p>';
      back.forEach(function (lim, i) { html += fieldHTML(i, lim, 'back', true); });
      html += '<p class="sdqs-backnote">The SiliDog logo is printed at the bottom of the back side.</p>';
    } else if (back.length) {
      html += '<details class="sdqs-back"><summary>Back of tag <em>(optional' + ')</em></summary>';
      back.forEach(function (lim, i) { html += fieldHTML(i, lim, 'back'); });
      html += '<p class="sdqs-backnote">The SiliDog logo is printed at the bottom of the back side.</p></details>';
    }
    var wrap = overlay.querySelector('.sdqs-fields');
    wrap.innerHTML = html;

    var add = overlay.querySelector('.sdqs-add');
    add.setAttribute('aria-disabled', 'true');
    var first = wrap.querySelector('[data-sdqs-key]');
    wrap.querySelectorAll('[data-sdqs-key]').forEach(function (inp) {
      inp.addEventListener('input', function () {
        inp.parentElement.querySelector('.sdqs-count').textContent = inp.value.length + '/' + inp.getAttribute('maxlength');
        if (inp === first) add.setAttribute('aria-disabled', first.value.trim() === '' ? 'true' : 'false');
      });
    });

    overlay.removeAttribute('hidden');
    // hides Klaviyo's popup while this is open (see silidog-quickshop.css)
    document.documentElement.classList.add('sdqs-open');
    setTimeout(function () { if (first) first.focus(); }, 40);
  }

  function close() {
    if (overlay) overlay.setAttribute('hidden', '');
    document.documentElement.classList.remove('sdqs-open');
    activeForm = null;
  }

  function gate(e) {
    // Products with options (SiliSlider: size x colour) show Horizon's "choose" button. Its
    // options popup has no personalization fields, and Monster Upsells also adds on this tap,
    // so it put SiliSliders in the cart with no text at all (18 web orders 10-15..10-29,
    // reproduced 2026-10-29). Send the shopper to the product page, which requires line 1.
    var choose = e.target && e.target.closest && e.target.closest('.quick-add__button--choose');
    if (choose) {
      var qa = choose.closest('.quick-add');
      var cf = qa && qa.querySelector('form[data-sdqs-url]');
      if (!cf || cf.getAttribute('data-sdqs-skip') === '1') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = cf.getAttribute('data-sdqs-url');
      return;
    }
    var btn = e.target && e.target.closest && e.target.closest('.quick-add__button--add');
    if (!btn) return;
    var form = btn.closest('form') || (btn.closest('.quick-add') && btn.closest('.quick-add').querySelector('form'));
    if (!form) return;
    if (form.getAttribute('data-sdqs-ok') === '1') return; // modal-approved re-fire
    e.preventDefault();
    e.stopImmediatePropagation();
    open(form);
  }
  // WINDOW capture, not document: Monster Upsells (cart_renderer_v2.js) also listens for click in
  // DOCUMENT capture, and same-phase listeners run in registration order. Depending on which script
  // loaded first, Monster sometimes ran first and posted /cart/add with NO personalization (blank tag
  // orders; reproduced on real touch taps 2026-09-18). Window capture always runs before any document
  // listener, so the gate wins deterministically.
  window.addEventListener('click', gate, true);

  // For custom cards that keep Horizon's quick-add form hidden and open the modal
  // from their own button (/collections preview cards). Same form, same contract.
  window.SiliDogQuickShop = { open: open };

  // belt-and-braces for any flow that submits the form directly
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.closest('.quick-add')) return;
    if (form.getAttribute('data-sdqs-ok') === '1') return;
    if (form.querySelector('input[name="properties[line1]"], input[name="properties[backline1]"]')) return;
    e.preventDefault();
    e.stopPropagation();
    open(form);
  }, true);
})();
